import React from 'react';
import SuccessCard from '../cards/SuccessCard';
import DangerCard from '../cards/DangerCard';
import NormalCard from '../cards/NormalCard';
import OverviewTable from '../overview-table/OverviewTable';
import INTAKE_API from 'api/intakeApi';
import { useFetch } from '@hooks/useBatchIntakeApi';
import OverViewCard from '@common-components/cards/OverViewCard';
import OverViewDangerCard from '@common-components/cards/OverViewDangerCard';

const Overview = () => {
  const params = {
    currentDate: new Date().toISOString().split("T")[0],
  };

  const { data: topSupplier, isLoading: isTopSupplierLoading } = useFetch("fetchTopSuplier", INTAKE_API.getTopSupplier);
  const { data: SupplierCompliance, isLoading: isSupplierComplianceLoading } = useFetch("fetchSupplierCompliance", INTAKE_API.getSupplierCompliance, params);
  const { data: suppliers } = useFetch("getSuppliers", INTAKE_API.getSuppliers, { PageNo: 0, PageSize: 10000 });

  const { data: intakeVolume, isLoading: isIntakeVolumeLoading } = useFetch("fetchIntakeVolume", INTAKE_API.getIntakeVolume, params);
  const { data: saleRevenue, isLoading: isSaleRevenueLoading } = useFetch("fetchSaleRevenue", INTAKE_API.getTotalSaleRevenue, params);
  const { data: profitMargin, isLoading: isProfitMarginLoading } = useFetch("fetchProfitMargin", INTAKE_API.getProfitMargin, params);

  const supplierName = suppliers?.data?.find(supplier => supplier.supplierID === topSupplier?.data?.supplierID)?.name || '';

  let saleData = {
    data: {
      volumePercentLastMonth: 10,
      intakeVolume: 100,
      saleRevenuePercentLastMonth: 10,
      totalSaleRevenue: 1000,
      profitMarginLastMonth: 10,
      profitMargin: 20,
    },
  };

  return (
    <React.Fragment>
      <div className='dx-card- lg:flex flex-col lg:flex-row justify-between lg:gap-3 lg:space-y-0 space-y-3 responsive-paddings-'>
        {isTopSupplierLoading ? (
          <div className="flex items-center justify-center h-24 w-full bg-gray-200 rounded animate-pulse">
            <div className="h-6 w-32 bg-gray-300 rounded"></div>
          </div>
        ) : (
          supplierName && (
            <SuccessCard
              title="Top Performing Supplier"
              stats={supplierName}
              trend="up"
              icon={<i class="ri-award-fill text-iconColor"></i>}
            />
          )
        )}
        {isSupplierComplianceLoading ? (
          <div className="flex items-center justify-center h-24 w-full bg-gray-200 rounded animate-pulse">
            <div className="h-6 w-32 bg-gray-300 rounded"></div>
          </div>
        ) : (
          <OverViewDangerCard
            title="Supplier Compliance"
            subtitleicon={SupplierCompliance?.data?.trend == "down" ? <i class="ri-arrow-down-s-fill text-red-800 text-[24px]"></i> : SupplierCompliance?.data?.trend === "up" ? <i class="ri-arrow-up-s-fill text-green-800 text-[24px]"></i> : null}
            trend={SupplierCompliance?.data?.trend}
            subtitle={`${SupplierCompliance?.data?.issueCount} vs last month`}
            stats={SupplierCompliance?.data?.percentage ? `${SupplierCompliance?.data?.percentage}%` : ''}
            icon={<i class="ri-user-follow-fill text-iconColor"></i>}
            statsicon={SupplierCompliance?.data?.trend == "down" ? <i class="ri-arrow-right-down-long-line"></i> : SupplierCompliance?.data?.trend === "up" ? <i class="ri-arrow-right-up-long-line"></i> : null}
          />
        )}
        {isIntakeVolumeLoading ? (
          <div className="flex items-center justify-center h-24 w-full bg-gray-200 rounded animate-pulse">
            <div className="h-6 w-32 bg-gray-300 rounded"></div>
          </div>
        ) : (
          <OverViewCard
            title="Intake Volume Processed"
            trend={intakeVolume?.data?.trend}
            subtitleicon={intakeVolume?.data?.trend == "down" ? <i class="ri-arrow-down-s-fill text-red-800 text-[24px]"></i> : <i class="ri-arrow-up-s-fill text-green-800 text-[24px]"></i>}
            subtitle={intakeVolume?.data?.volume ? `${intakeVolume?.data?.volume} kg vs last month` : ''}
            stats={intakeVolume?.data?.percentage ? `${intakeVolume?.data?.percentage}%` : ''}
            icon={<i class="ri-stock-fill text-iconColor"></i>}
            statsicon={intakeVolume?.data?.trend == "down" ? <i class="ri-arrow-right-down-long-line"></i> : <i class="ri-arrow-right-up-long-line"></i>}
          />
        )}
        {isSaleRevenueLoading ? (
          <div className="flex items-center justify-center h-24 w-full bg-gray-200 rounded animate-pulse">
            <div className="h-6 w-32 bg-gray-300 rounded"></div>
          </div>
        ) : (
          <OverViewCard
            title="Total Sales Revenue"
            trend={saleRevenue?.data?.trend}
            subtitleicon={saleRevenue?.data?.trend == "down" ? <i class="ri-arrow-down-s-fill text-red-800 text-[24px]"></i> : <i class="ri-arrow-up-s-fill text-green-800 text-[24px]"></i>}
            subtitle={saleRevenue?.data?.revenue ? `€ ${saleRevenue?.data?.revenue} vs last month` : ''}
            stats={saleRevenue?.data?.percentage ? `${saleRevenue?.data?.percentage}%` : ''}
            icon={<i class="ri-money-euro-circle-fill text-iconColor"></i>}
            statsicon={saleRevenue?.data?.trend == "down" ? <i class="ri-arrow-right-down-long-line"></i> : <i class="ri-arrow-right-up-long-line"></i>}
          />
        )}
        {isProfitMarginLoading ? (
          <div className="flex items-center justify-center h-24 w-full bg-gray-200 rounded animate-pulse">
            <div className="h-6 w-32 bg-gray-300 rounded"></div>
          </div>
        ) : (
          <OverViewCard
            title="Profit Margin"
            trend={profitMargin?.data?.trend}
            subtitleicon={profitMargin?.data?.trend == "down" ? <i class="ri-arrow-down-s-fill text-red-800 text-[24px]"></i> : <i class="ri-arrow-up-s-fill text-green-800 text-[24px]"></i>}
            subtitle={profitMargin?.data?.profitMargin ? `€ ${profitMargin?.data?.profitMargin} vs last month` : ''}
            stats={profitMargin?.data?.percentage ? `${profitMargin?.data?.percentage}%` : ''}
            icon={<i class="ri-funds-fill text-iconColor"></i>}
            statsicon={profitMargin?.data?.trend == "down" ? <i class="ri-arrow-right-down-long-line"></i> : <i class="ri-arrow-right-up-long-line"></i>}
          />
        )}
      </div>
      <div className='mt-4'>
        <OverviewTable />
      </div>
    </React.Fragment>
  );
}

export default Overview;
